import './image-slider.scss';
import Swiper from '../../vendor/swiper/swiper';
require('../../assets/images/slider-arrow-active.svg');
require('../../assets/images/slider-arrow-inactive.svg');

class ImageSlider {
    constructor ($element) {
        this.$imageSlider = $element;
        this.$slider = this.$imageSlider.querySelector('[data-image-slider="slider"]');
        this.sliderCount = this.$imageSlider.querySelector('[data-slider-count]').getAttribute('data-slider-count');
        this.$slidePrev = this.$imageSlider.querySelector('[data-image-slider="prev"]');
        this.$slideNext = this.$imageSlider.querySelector('[data-image-slider="next"]');
        this.$slideImage = this.$imageSlider.querySelector('[data-image-slider="image"]');
        this.$sliderNav = this.$imageSlider.querySelector('[data-image-slider="nav"]');

        this.slider = null;
    }

    initialize () {
        this.checkSize();
        this.setPosition();
    }

    checkSize () {
        if (window.innerWidth < 1440 || this.sliderCount > 4) {
            if (this.slider === null) {
                this.initSlider();
                this.setPosition();
            }
        }

        window.resizeHandler.customFunctions.push(() => {
            if (window.innerWidth < 1440 || this.sliderCount > 4) {
                if (this.slider === null) {
                    this.initSlider();
                    this.setPosition();
                }
            } else {
                this.destroySlider();
            }

            this.setPosition();
        });
    }

    initSlider () {
        this.slider = new Swiper(this.$imageSlider, {
            centeredSlides: true,
            initialSlide: 1,
            slidesPerView: 1.4,
            spaceBetween: 20,
            speed: 500,
            breakpointsInverse: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            breakpoints: {
                540: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    centeredSlides: false,
                    initialSlide: false
                },
                767: {
                    slidesPerView: 3,
                    spaceBetween: 25,
                    centeredSlides: false,
                    initialSlide: false
                },
                1440: {
                    slidesPerView: 4,
                    spaceBetween: 45,
                    centeredSlides: false,
                    initialSlide: false
                }
            }
        });

        this.$slidePrev.addEventListener('click', () => {
            this.slider.slidePrev();
        });

        this.$slideNext.addEventListener('click', () => {
            this.slider.slideNext();
        });
    }

    destroySlider () {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
        }
    }

    // calculate position of slider nav
    setPosition () {
        this.$sliderNav.style.top = this.$slideImage.offsetHeight / 2 + 'px';
    }
}

export { ImageSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $imageSliders = $context.querySelectorAll('[data-image-slider="root"]');

    if ($imageSliders.length > 0) {
        for (let i = 0; i < $imageSliders.length; i++) {
            const $imageSlider = new ImageSlider($imageSliders[i]);
            $imageSlider.initialize();
        }
    }
});
